<div class="container-fluid">
  <form *ngIf="rsjForm" [formGroup]="rsjForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12 mt-2">
        <h5 class="text-primary">Informations de Suivi</h5>
      </div>
    </div>
    <div class="row mt-2">
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label class="required">Statut du dossier</label>
        <select class="form-select" formControlName="rsjState" [class.is-invalid]="submitted && rsjForm.controls?.rsjState?.errors?.required">
          <option *ngIf="!rsjForm.value.rsjState" [ngValue]="" selected hidden></option>
          <option [ngValue]="state.id" *ngFor="let state of rsjStates">
            {{ state.label }}
          </option>
        </select>
        <small *ngIf="submitted && rsjForm.controls?.rsjState?.errors?.required" class="form-text text-danger"
          >Le statut du dossier est requis.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label>Ouverture des droits</label>
        <app-datepicker
          id="fieldBeginDateRsj"
          formControlName="beginDateRsj"
          [invalid]="submitted && (rsjForm.controls?.beginDateRsj?.invalid || rsjForm.errors?.datesOrder)"
        >
        </app-datepicker>
        <small *ngIf="submitted && rsjForm.controls?.beginDateRsj?.errors?.dateFormat" class="form-text text-danger"
          >La date d'ouverture des droits est invalide.</small
        >
        <small *ngIf="submitted && rsjForm.controls?.beginDateRsj?.errors?.required" class="form-text text-danger"
          >La date d'ouverture des droits est requise.</small
        >
        <small *ngIf="submitted && rsjForm.errors?.datesOrder" class="form-text text-danger"
          >La date d'ouverture des droits est incohérente avec la date de clôture.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label>Clôture</label>
        <app-datepicker
          id="fieldEndDateRsj"
          formControlName="endDateRsj"
          [invalid]="submitted && (rsjForm.controls?.endDateRsj?.invalid || rsjForm.errors?.datesOrder)"
        >
        </app-datepicker>
        <small *ngIf="submitted && rsjForm.controls?.endDateRsj?.errors?.dateFormat" class="form-text text-danger"
          >La date de clôture est invalide.</small
        >
        <small *ngIf="submitted && rsjForm.controls?.endDateRsj?.errors?.required" class="form-text text-danger"
          >La date de clôture est requise.</small
        >
        <small *ngIf="submitted && rsjForm.errors?.datesOrder" class="form-text text-danger"
          >La date de clôture est incohérente avec la date d'ouverture des droits.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label>Motif de fin</label>
        <select
          class="form-select"
          formControlName="rsjCloseReason"
          [class.is-invalid]="submitted && rsjForm.controls?.rsjCloseReason?.errors?.required"
        >
          <option *ngIf="!rsjForm.value.rsjCloseReason" [ngValue]="" selected hidden></option>
          <option [ngValue]=""></option>
          <option [ngValue]="reason.id" *ngFor="let reason of rsjCloseReasons">
            {{ reason.label }}
          </option>
        </select>
        <small *ngIf="submitted && rsjForm.controls?.rsjCloseReason?.errors?.required" class="form-text text-danger"
          >Le motif de fin est requis.</small
        >
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <h5 class="text-primary">Référent</h5>
      </div>
    </div>
    <div class="row mt-2" formGroupName="referentForm">
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label>Référent</label>
        <select
          class="form-select"
          formControlName="referent"
          [class.is-invalid]="
            (submitted || referentHistorized) &&
            (referentForm.errors?.rsjReferentFullRequired ||
              referentForm.errors?.rsjReferentPartialRequired ||
              referentForm.controls?.referent?.invalid)
          "
        >
          <option *ngIf="!referentForm.value.referent" [ngValue]="" selected hidden></option>
          <option [ngValue]=""></option>
          <option *ngFor="let referent of referentList" [ngValue]="referent.id">
            {{ referent.name }}
          </option>
        </select>
        <small
          *ngIf="
            (submitted || referentHistorized) &&
            (referentForm.errors?.rsjReferentFullRequired ||
              referentForm.errors?.rsjReferentPartialRequired ||
              referentForm.controls?.referent?.errors?.required)
          "
          class="form-text text-danger"
          >Le référent est requis.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label>Début</label>
        <app-datepicker
          id="fieldBeginDate"
          formControlName="beginDateReferent"
          [invalid]="
            (submitted || referentHistorized || isntBeginWithinOri) &&
            (referentForm.controls?.beginDateReferent?.invalid ||
              referentForm.errors?.datesOrder ||
              referentForm.errors?.rsjReferentFullRequired ||
              referentForm.errors?.rsjReferentPartialRequired ||
              isntBeginWithinOri)
          "
        ></app-datepicker>
        <small *ngIf="(submitted || referentHistorized) && referentForm.controls?.beginDateReferent?.errors?.dateFormat" class="form-text text-danger"
          >La date de début de référent est invalide.</small
        >
        <small
          *ngIf="
            (submitted || referentHistorized) &&
            (referentForm.errors?.rsjReferentFullRequired ||
              referentForm.errors?.rsjReferentPartialRequired ||
              referentForm.controls?.beginDateReferent?.errors?.required)
          "
          class="form-text text-danger"
          >La date de début de référent est requise.</small
        >
        <small *ngIf="(submitted || referentHistorized) && referentForm.errors?.datesOrder" class="form-text text-danger"
          >La date de début est incohérente avec la date de fin.</small
        >
        <small *ngIf="isntBeginWithinOri" class="form-text text-danger">La date de début doit être comprise dans la période d'orientation.</small>
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
        <label>Fin</label>
        <app-datepicker
          id="fieldEndDate"
          formControlName="endDateReferent"
          [invalid]="
            (submitted || referentHistorized || isntEndWithinOri) &&
            (referentForm.controls?.endDateReferent?.invalid ||
              referentForm.errors?.datesOrder ||
              referentForm.errors?.rsjReferentFullRequired ||
              isntEndWithinOri)
          "
        ></app-datepicker>
        <small *ngIf="(submitted || referentHistorized) && referentForm.controls?.endDateReferent?.errors?.dateFormat" class="form-text text-danger"
          >La date de fin de référent est invalide.</small
        >
        <small
          *ngIf="
            (submitted || referentHistorized) &&
            (referentForm.errors?.rsjReferentFullRequired || referentForm.controls?.endDateReferent?.errors?.required)
          "
          class="form-text text-danger"
          >La date de fin de référent est requise.</small
        >
        <small *ngIf="(submitted || referentHistorized) && referentForm.errors?.datesOrder" class="form-text text-danger"
          >La date de fin est incohérente avec la date de début.</small
        >
        <small *ngIf="isntEndWithinOri" class="form-text text-danger">La date de fin doit être comprise dans la période d'orientation.</small>
      </div>
      <div class="d-grid mb-3 col-12 col-lg-12 col-xl-2 mt-4 ms-auto">
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
          (click)="historizeReferent()"
          style="margin-top: 1px"
        >
          Historiser
        </button>
      </div>
    </div>
    <div *ngIf="!hasOrientation" class="row ms-4 mb-2">
      <small class="form-text text-danger">Le bénéficiaire doit être orienté pour avoir un référent RSJ.</small>
    </div>

    <!-- Tableau historique des référents -->
    <div class="card border-0 card-border-radius-0">
      <div class="card-body p-0">
        <div class="table-responsive">
          <div ngbAccordion [closeOthers]="false">
            <div ngbAccordionItem>
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="accordion-button text-secondary">
                  <span id="rsjReferentHistorytitle">Référents RSJ historisés</span>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <p *ngIf="!hasHistorizedRsjReferent">Le bénéficiaire n'a aucune historisation de référent RSJ.</p>
                    <div class="col px-0 pt-2" *ngIf="hasHistorizedRsjReferent">
                      <table class="table table-striped table-hover" aria-describedby="rsjReferentHistorytitle">
                        <thead class="text-secondary bg-light">
                          <tr>
                            <th scope="col" class="text-center"></th>
                            <th scope="col" class="text-center">Début</th>
                            <th scope="col" class="text-center">Fin</th>
                            <th scope="col" class="text-center">Structure</th>
                            <th scope="col" class="text-center">Référent</th>
                            <th scope="col" class="text-center"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let referent of beneficiaryReferents">
                            <tr *ngIf="referent.type === 'RSJ' && referent.historized">
                              <td></td>
                              <td class="text-center">
                                {{ referent.beginDate | date }}
                              </td>
                              <td class="text-center">
                                {{ referent.endDate | date }}
                              </td>
                              <td class="text-center">
                                {{ referent.user.structureLabel }}
                              </td>
                              <td class="text-center">
                                {{ referent.user.name }}
                              </td>
                              <td class="text-center">
                                <button
                                  [style.display]="referent.id ? 'block' : 'none'"
                                  type="button"
                                  (click)="deleteReferentHistory(referent)"
                                  *appOnlyGroups="['ADMIN', 'DIRECTION+']"
                                  class="btn btn-sm btn-primary"
                                  ngbTooltip="Supprimer"
                                >
                                  <fa-icon icon="trash-alt"></fa-icon>
                                </button>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-1 my-3" *appOnlyGroups="['STRUCTURE', 'DIRECTION+']">
      <small *ngIf="isInvalidReferent" class="form-text text-danger"
        >L'historisation de référent du bénéficiaire est invalide, veuillez contacter un administrateur.</small
      >
    </div>
    <div class="mx-1 my-3" *appOnlyGroups="['ADMIN']">
      <small *ngIf="isInvalidReferent" class="form-text text-danger"
        >L'historisation de référent RSJ est invalide, veuillez supprimer les lignes incohérentes et re-créer l'historisation à l'aide du référent
        actuel.</small
      >
    </div>
    <div class="row mx-0 my-4">
      <div class="d-grid ms-auto col-md-6 col-3 col-lg-3 col-xl-2 px-0">
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          (click)="cancel()"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
        >
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-2 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 col-xl-2 pe-0">
        <button class="btn btn-primary d-flex justify-content-center" type="submit" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']">
          <fa-icon icon="save"></fa-icon>
          <span class="ms-2 d-none d-md-block">Sauvegarder</span>
        </button>
      </div>
    </div>
  </form>
</div>
